import { PropsWithChildren, ReactNode, useCallback } from 'react';
import { MdOutlineClear } from 'react-icons/md';
import { Drawer, DrawerContent, DrawerHeader, DrawerBody, Spinner } from '@ds';

type RoutePlannerSideDrawerProps = {
  title: string | ReactNode;
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  isKeyboardDismissDisabled?: boolean;
  isDismissable?: boolean;
};

export const RoutePlannerSideDrawer = ({
  title,
  children,
  isOpen,
  isLoading = false,
  onClose,
  isKeyboardDismissDisabled = false,
  isDismissable = true,
}: PropsWithChildren<RoutePlannerSideDrawerProps>) => {
  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) onClose();
    },
    [onClose],
  );

  return (
    <Drawer
      placement="right"
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      isDismissable={isDismissable}
      isKeyboardDismissDisabled={isKeyboardDismissDisabled}
      backdrop="transparent"
      closeButton={
        <div className="text-base-20">
          <MdOutlineClear size={24} />
        </div>
      }
      classNames={{
        wrapper:
          'z-418 w-auto right-0 left-auto top-[52px] h-[calc(var(--visual-viewport-height)-52px)] overflow-x-hidden',
        base: 'h-full relative bg-base-90 max-w-none',
        backdrop: 'hidden pointer-events-none',
        header: 'font-secondary text-hl p-0 text-[#55525F]!',
        body: 'p-0',
        closeButton: 'top-7 right-4',
      }}
    >
      <DrawerContent className="ml-auto h-full w-140 max-w-[90vw] rounded-l-xl p-6 flex flex-col gap-4 overflow-x-hidden">
        {() => (
          <>
            <DrawerHeader>{title}</DrawerHeader>
            <DrawerBody className="p-0 overflow-x-hidden">
              {isLoading ? (
                <div className="flex justify-center items-center w-full h-full">
                  <Spinner size="md" />
                </div>
              ) : (
                children
              )}
            </DrawerBody>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
};
